import { buildPredefinedDemoGift } from "../constants/predefinedEcardDemos";

/** Stable 0–3 from gift id when URL has no `variant` param. */
export function variantIndexFromGiftId(id, max = 4) {
  const s = String(id || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % max;
}

/**
 * Same image triple as `/ecard/:occasion?variant=n` (predefined demo layers).
 */
export function getEcardSampleLayerUrls(occasionSlug, variantIndex) {
  const g = buildPredefinedDemoGift(occasionSlug, variantIndex);
  return [g.Image1, g.image2, g.image3].filter(Boolean);
}

/**
 * Gallery URLs: predefined sample layers first (match /ecard experience), then unique product URLs.
 */
export function buildProductLandingGallery(product, occasionSlug, variantIndex) {
  const sample = getEcardSampleLayerUrls(occasionSlug, variantIndex);
  const own = [product.imageurl, product.image2, product.image3, product.coverurl].filter(Boolean);
  const out = [...sample];
  for (const u of own) {
    if (u && !out.includes(u)) out.push(u);
  }
  return out.length ? out : sample;
}
